import type { QueuedChangeFailureEvents } from 'shared/channels/entity';
import { defineChannelContract } from 'shared/channels';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import type {
  SharedReportSignedUrlRequest,
  SharedResourceSignedRequestResult,
} from 'shared/download/sharedResourceSignedRequest';
import type { CreateReportModel } from './types/model/createReportPayload';

/** Report requests answered by the service worker and the events it broadcasts. */
export const reportContract = defineChannelContract<{
  requests: {
    /** The result follows as `createdEntity` with `uniqueId`, an error included. */
    create: { request: { report: CreateReportModel; uniqueId: string }; response: void };
    getSignedUrl: {
      request: SharedReportSignedUrlRequest;
      response: SharedResourceSignedRequestResult;
    };
  };
  events: QueuedChangeFailureEvents & {
    // The server's answer to the report request; the page only waits for it.
    [DomainMessagesTypes.createdEntity]: unknown;
    // Never sent: a failed report is `createdEntity` with `error`. Required by `runQueuedMutation`.
  };
}>('reportChannel');
